import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = '/response-payments'

export default {
  getPaymentsData(settings) {
    return Repository.get(action + getParamsUrl(settings))
  },
  postPayment(data) {
    return Repository.post(action, data)
  },
  postMassPayments(data) {
    return Repository.post(`${action}/mass-create`, data)
  },
  getTotalDebt() {
    return Repository.get(action + '/total-pending')
  },
  getMassExportPayments(settings) {
    return Repository.get(action + '/mass-export' + getParamsUrl(settings), {
      responseType: 'blob',
    })
  },
}
